import styled from 'styled-components';

export type RadioCheckboxSizeValue = 'lg' | 'sm';

const RADIO_CHECK_SIZES = {
  sm: { outer: 1, checkHeight: 0.5728, checkWidth: 0.312, radioInner: 0.375 },
  lg: { outer: 1.25, checkHeight: 0.6875, checkWidth: 0.375, radioInner: 0.5 },
  xl: { outer: 1.25, checkHeight: 0.6875, checkWidth: 0.375, radioInner: 0.5 }, // xl is here for legacy reasons, but the design system only supports small and large
};

export const getRadioCheckOuterSize = (size: RadioCheckboxSizeValue): string => {
  if (size === 'lg') return `${RADIO_CHECK_SIZES.lg.outer}rem`;
  return `${RADIO_CHECK_SIZES.sm.outer}rem`;
};

export const getRadioInnerSize = (size: RadioCheckboxSizeValue | 'xl'): string => {
  if (size === 'xl') return `${RADIO_CHECK_SIZES.xl.radioInner}rem`;
  if (size === 'lg') return `${RADIO_CHECK_SIZES.lg.radioInner}rem`;
  return `${RADIO_CHECK_SIZES.sm.radioInner}rem`;
};

export const getCheckHeight = (size: RadioCheckboxSizeValue): string => {
  if (size === 'lg') return `${RADIO_CHECK_SIZES.lg.checkHeight}rem`;
  return `${RADIO_CHECK_SIZES.sm.checkHeight}rem`;
};

export const getCheckWidth = (size: RadioCheckboxSizeValue): string => {
  if (size === 'lg') return `${RADIO_CHECK_SIZES.lg.checkWidth}rem`;
  return `${RADIO_CHECK_SIZES.sm.checkWidth}rem`;
};

/** Styled Components */
/* Customize the label (the container) */
type LabelProps = {
  $size: RadioCheckboxSizeValue;
  disabled: boolean;
};

export const RadioCheckboxLabel = styled.label<LabelProps>`
  color: ${(props): string =>
    props.disabled ? props.theme.designSystem.textColors.disabled : props.theme.designSystem.textColors.default};
  cursor: ${(props): string => (props.disabled ? 'default' : 'pointer')};
  font-size: 1rem;
  line-height: ${(props): string => (props.$size === 'lg' ? '1.25' : '1')};
  min-height: ${(props): string => (props.$size === 'lg' ? '1.25rem' : '1rem')};
  position: relative;
  transition: color 0.3s ease;
  user-select: none;
  display: grid;
  grid-template-columns: 1em auto;
  gap: ${(props): string => {
    if (props.$size === 'lg') return '0.75em';
    return '0.5em';
  }};
  align-items: center;
  margin: 0;
`;

export type Option = { value: string; label: string };

export const validateRadioCheckOptionsProp = ({
  options,
  componentName,
}: {
  options: Option[];
  componentName: string;
}) => {
  const arr = Array.isArray(options) ? options : [];
  const valuesList = [];
  return arr.filter((opt, index) => {
    if (!opt?.value) {
      console.warn(`${componentName}: option with index ${index} is missing a value`);
      return false;
    }

    if (!opt?.label) {
      console.warn(`${componentName}: option with index ${index} is missing a label`);
      return false;
    }

    if (valuesList.includes(opt.value)) {
      console.warn(`${componentName}: found multiple options with value "${opt.value}"`);
      return false;
    }

    valuesList.push(opt.value);
    return true;
  });
};
